import api from "../services/api";

export const RECENT_CONTEXT_LIMIT_DEFAULT = 8;

export async function listarContextoRecente(limit = RECENT_CONTEXT_LIMIT_DEFAULT) {
  try {
    const { data } = await api.get("/recent-contexts", {
      params: { limit }
    });
    return data;
  } catch (err) {
    return { rows: [], count: 0 };
  }
}

let _ultimoTouchPorChave = new Map();

export function devePularTouch(chave, agora = Date.now(), janelaMs = 60_000) {
  const antes = _ultimoTouchPorChave.get(chave);
  if (antes && agora - antes < janelaMs) return true;
  _ultimoTouchPorChave.set(chave, agora);
  return false;
}

export async function tocarContexto(payload) {
  if (!payload?.entityType || !payload?.entityId) return null;

  const chave = `${payload.entityType}:${payload.entityId}`;
  if (devePularTouch(chave)) return null;

  try {
    const { data } = await api.post("/recent-contexts/touch", payload, {
      timeout: 5_000
    });
    return data;
  } catch (_err) {
    return null;
  }
}

export function touchTicket(ticket, extra = {}) {
  if (!ticket?.id) return;
  const contactName = ticket.contact?.name || ticket.contactName || "Contato";
  return tocarContexto({
    entityType: "ticket",
    entityId: Number(ticket.id),
    contextTitle: contactName,
    contextSubtitle:
      ticket.lastMessage ||
      (ticket.status ? `Status: ${ticket.status}` : undefined) ||
      null,
    contextPath: `/tickets/${ticket.id}`,
    entityIcon: "MessageSquare",
    ...extra
  });
}

export function touchContact(contact, extra = {}) {
  if (!contact?.id) return;
  return tocarContexto({
    entityType: "contact",
    entityId: Number(contact.id),
    contextTitle: contact.name || "Contato",
    contextSubtitle:
      contact.number || contact.email || contact.mainWhatsapp || null,
    contextPath: contact.timelinePath || `/contacts/${contact.id}/timeline`,
    entityIcon: "User",
    ...extra
  });
}

export function touchTask(item, extra = {}) {
  if (!item?.id) return;
  return tocarContexto({
    entityType: "task",
    entityId: Number(item.id),
    contextTitle: item.title || item.name || "Tarefa",
    contextSubtitle:
      (item.status ? `Status: ${item.status}` : "") +
      (item.dueDate ? ` · Vence: ${item.dueDate}` : "") ||
      null,
    contextPath: item.path || `/tarefas#item-${item.id}`,
    entityIcon: "CheckSquare",
    ...extra
  });
}

export function touchInternalChat(chat, extra = {}) {
  if (!chat?.id) return;
  return tocarContexto({
    entityType: "internalChat",
    entityId: Number(String(chat.id).replace("internal-", "")),
    contextTitle: chat.name || chat.title || "Conversa interna",
    contextSubtitle: chat.lastMessage || chat.participants || null,
    contextPath: `/tickets/internal-${String(chat.id).replace("internal-", "")}`,
    entityIcon: "Users",
    ...extra
  });
}

export function touchCampaign(campaign, extra = {}) {
  if (!campaign?.id) return;
  return tocarContexto({
    entityType: "campaign",
    entityId: Number(campaign.id),
    contextTitle: campaign.name || "Campanha",
    contextSubtitle: campaign.status || null,
    contextPath: `/campanhas/${campaign.id}`,
    entityIcon: "Megaphone",
    ...extra
  });
}

export function touchFlow(flow, extra = {}) {
  if (!flow?.id) return;
  return tocarContexto({
    entityType: "flow",
    entityId: Number(flow.id),
    contextTitle: flow.name || "Fluxo",
    contextSubtitle: flow.status || null,
    contextPath: `/flow-builder/${flow.id}`,
    entityIcon: "GitBranch",
    ...extra
  });
}

export function touchScheduledMessage(sm, extra = {}) {
  if (!sm?.id) return;
  return tocarContexto({
    entityType: "scheduledMessage",
    entityId: Number(sm.id),
    contextTitle: sm.contactName || "Mensagem agendada",
    contextSubtitle: sm.scheduledAt || null,
    contextPath: `/agendamentos#${sm.id}`,
    entityIcon: "Clock",
    ...extra
  });
}

export function touchTicketNote(ticket, acao = "Anotação", extra = {}) {
  if (!ticket?.id) return;
  return tocarContexto({
    entityType: "ticketNote",
    entityId: Number(ticket.id),
    contextTitle: ticket.contact?.name || ticket.contactName || "Ação operacional",
    contextSubtitle: acao,
    contextPath: `/tickets/${ticket.id}`,
    entityIcon: "StickyNote",
    ...extra
  });
}
